import React, { useEffect, useState } from "react";
import styled from "styled-components";
import NumberHolder from "./NumberHolder";

const GridHolder = styled.div`
    position: relative;
    left: 4%;
    height: 100%,
    display: flex,
    flex-direction: column,
    justify-content: center,
    align-tems: center,
`;

const NumberRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const CurrentNumberHolder = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 1%;
  left: 1%;
`;

const CurrentNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  font-size: 19px;
  margin-left: 5px;
  background-color: #f2cdce;
  border-radius: 25px;
`;

function shuffleArray(a: number[]) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const AMOUNT_OF_NUMBERS = 50;
const ROW_COUNT = AMOUNT_OF_NUMBERS / 5;

const generateNumberArray = (level: number) => {
  let numbers = new Array(AMOUNT_OF_NUMBERS);
  for (let i = 0; i < numbers.length; i++) {
    numbers[i] = i + 1;
  }

  const shuffledArray = shuffleArray(numbers);
  if (level === 3) {
    const indexFirst = shuffledArray.indexOf(1);
    const firstNumber = shuffledArray[0];
    shuffledArray[0] = 1;
    shuffledArray[indexFirst] = firstNumber;
  }
  return shuffledArray;
};

export default ({ level, disabled, shuffle, setGameOver }: any) => {
  const [numbers, setNumbers] = useState(generateNumberArray(level));
  const [rows, setRows] = useState(new Array(ROW_COUNT - 1));
  const [currentNumber, setCurrentNumber] = useState(1);
  const [numberOfPickedNumbers, setNumberOfPickedNumbers] = useState(0);

  useEffect(() => {
    setNumbers(generateNumberArray(level));
    setNumberOfPickedNumbers(0);
    let newRows = new Array(ROW_COUNT - 1);
    let k = 0;
    for (let i = 0; i < ROW_COUNT; i++) {
      let row: number[] = new Array(5);
      for (let j = 0; j < 5; j++) {
        row[j] = numbers[k];
        k++;
      }
      newRows[i] = row;
    }
    setRows(newRows);
  }, [shuffle, level]);

  useEffect(() => {
    setCurrentNumber(
      level === 2 ? AMOUNT_OF_NUMBERS : level === 1 ? 1 : numbers[0]
    );
  }, [numbers]);

  useEffect(() => {
    if (
      (level == 1 && currentNumber === 51) ||
      (level == 2 && currentNumber === 0) ||
      numberOfPickedNumbers == AMOUNT_OF_NUMBERS
    )
      setGameOver(true);
  }, [currentNumber]);

  return (
    <>
      {level === 3 && (
        <CurrentNumberHolder>
          Finden Sie Nummer{" "}
          <CurrentNumber>
            <strong>{currentNumber}</strong>
          </CurrentNumber>
        </CurrentNumberHolder>
      )}
      <GridHolder>
        {rows.map((row) => {
          return (
            <NumberRow>
              {row.map((number: number) => {
                return (
                  <NumberHolder
                    number={number}
                    currentNumber={currentNumber}
                    setCurrentNumber={setCurrentNumber}
                    disabled={disabled}
                    level={level}
                    shuffle={shuffle}
                    numbers={numbers}
                    setNumberOfPickedNumbers={setNumberOfPickedNumbers}
                    numberOfPickedNumbers={numberOfPickedNumbers}
                  />
                );
              })}
            </NumberRow>
          );
        })}
      </GridHolder>
    </>
  );
};
